import 'vue-slider-component/theme/default.css'
import 'vuetify/dist/vuetify.min.css'

import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/browser'
import * as VueGoogleMaps from 'vue2-google-maps'
import '@mdi/font/css/materialdesignicons.css'

import { Chart, registerables } from 'chart.js'
import { Drag, Drop } from 'vue-drag-drop'

import ApolloProvider from './apollo'
import App from './App.vue'
import VModal from 'vue-js-modal'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueDraggableResizable from 'vue-draggable-resizable'
import VueSocialSharing from 'vue-social-sharing'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import LanguageDetector from 'i18next-browser-languagedetector'
import translation from './assets/translation.ts'
import AdminI18n from './admin-i18n'
import axios from 'axios'
import { adminRouteContext } from './admin-i18n/route-context'
import { adminVuetifyText } from './admin-i18n/vuetify'
import { router } from './routing/'
import store from './store'
import VueSkeletonLoader from 'skeleton-loader-vue'

Chart.register(...registerables)

Vue.prototype.$bus = new Vue() // Event bus

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENVIRONMENT,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  enabled: process.env.VUE_APP_ENVIRONMENT !== 'development',
})

Vue.use(VueSocialSharing)
Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.config.productionTip = process.env.VUE_APP_ENVIRONMENT === 'production'
Vue.component('drag', Drag)
Vue.component('drop', Drop)
Vue.use(Vuelidate)
Vue.use(VueClipboard)
Vue.component('vue-skeleton-loader', VueSkeletonLoader)

Vue.directive('hide', {
  update(el, binding) {
    if (binding.value) el.style.visibility = 'hidden'
    else el.style.visibility = 'visible'
  },
})

Vue.directive('click-outside', {
  bind() {
    this.event = event => this.vm.$emit(this.expression, event)
    this.el.addEventListener('click', this.stopProp)
    document.body.addEventListener('click', this.event)
  },
  unbind() {
    this.el.removeEventListener('click', this.stopProp)
    document.body.removeEventListener('click', this.event)
  },

  stopProp(event) {
    event.stopPropagation()
  },
})

Vue.use(Vuetify, {
  lang: {
    t(key, ...params) {
      const route = router.app ? router.app.$route : router.currentRoute
      const translate = adminRouteContext(route) === true && Vue.prototype.$adminT
        ? Vue.prototype.$adminT : (key, source) => source

      return adminVuetifyText(key, params, translate)
    },
  },
  iconfont: 'mdi',
  theme: {
    primary: '#0277BD',
    secondary: '#FF4C00',
    accent: '#0277BD',
    error: '#DB384C',
    errorDark: '#BD2A3C',
    info: '#0277BD',
    success: '#4CAF50',
    warning: '#FFC107',
    dinamoBlue: '#0054A5',
    grey_00: '#333',
  },
})

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
    libraries: 'places',
  },
})

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
})

Vue.use(VModal, { componentName: 'vue-modal' })

require('blueimp-canvas-to-blob')
require('cropperjs/dist/cropper.css')
require('./mixins')
require('./directives')
require('./components/shared/inputs')
require('./components/shared/main-button')
require('./components/shared/spinner')

Vue.use(AdminI18n, {
  loadFlags: async () => {
    const { data } = await axios.get(`${process.env.VUE_APP_SERVER_URL}/ui/features`, { timeout: 5000 })

    return data
  },
})

Vue.use(I18NextVue, {
  i18next,
})

// i18next is only used on pages that customers see (registration,etc) this is not for general application translations
i18next.on('initialized', async () => {
  i18next.addResourceBundle('en', 'default', translation.en.default, true, false)
  i18next.addResourceBundle('hr', 'default', translation.hr.default, true, false)
  await i18next.changeLanguage('en')

  new Vue({
    router,
    store,
    render: h => h(App),
    apolloProvider: ApolloProvider,
  }).$mount('#app')
})

// When we land on the registration form we check the query params for a lang
// which will set everything apart from custom attendee fields which have their own translation
const getFallbackLanguageCodeFromQueryParams = () => {
  const params = new URL(window.location.href).searchParams

  return params.get('lang') || 'en'
}

i18next.use(LanguageDetector).init({
  debug: false,
  fallbackLng: getFallbackLanguageCodeFromQueryParams(window.location.href),
  ns: [],
  defaultNS: 'default',
  partialBundledLanguages: true,
  resources: {},
})
